import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import _ from 'lodash';
import * as React from 'react';
import PreferencePill from '../../preferences/PreferencePill';
import { PreferenceDisplay } from '../../../types/Preference';

interface PreferencesPopoverProps {
  values: Array<string | PreferenceDisplay>;
}

const normalize = (v: string | PreferenceDisplay): PreferenceDisplay => (_.isString(v) ? { value: v } : v);

const PreferencesPopover: React.FC<PreferencesPopoverProps> = ({ values }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'preferences-popover' : undefined;

  if (values.length === 0) return null;

  const items = _.map(values, normalize);

  return (
    <Stack direction="row" alignItems="center" sx={{ flexWrap: 'nowrap' }}>
      <PreferencePill value={items[0].value} color={items[0].color} />
      {items.length > 1 && (
        <>
          <IconButton onClick={handleClick} size="small">
            <MoreHorizIcon />
          </IconButton>
          <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
            <Stack spacing={1} sx={{ p: 2 }}>
              {_.map(_.slice(items, 1), (item, index) => (
                <PreferencePill key={index} value={item.value} color={item.color} />
              ))}
            </Stack>
          </Popover>
        </>
      )}
    </Stack>
  );
};

export default PreferencesPopover;
